/* tslint:disable */
/* eslint-disable */
/**
 * Commerce Webservices
 * Manages all of the common commerce functionality, and also includes customizations from installed AddOns. The implementing extension is called commercewebservices.
 *
 * The version of the OpenAPI document: 2.2.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  Address,
  ErrorList,
} from '../models';
import {
    AddressFromJSON,
    AddressToJSON,
    ErrorListFromJSON,
    ErrorListToJSON,
} from '../models';

export interface CreateCartDeliveryAddressRequest {
    baseSiteId: string;
    cartId: string;
    userId: string;
    address: Address;
    fields?: string;
    sapCommerceCloudCustomerId?: string;
}

export interface CreateCartPaymentAddressRequest {
    baseSiteId: string;
    cartId: string;
    userId: string;
    address: Address;
    fields?: string;
    sapCommerceCloudCustomerId?: string;
}

export interface RemoveCartDeliveryAddressRequest {
    baseSiteId: string;
    cartId: string;
    userId: string;
    sapCommerceCloudCustomerId?: string;
}

export interface RemovePaymentAddressRequest {
    baseSiteId: string;
    cartId: string;
    id: string;
    userId: string;
    removeFromAddressBook?: boolean;
    sapCommerceCloudCustomerId?: string;
}

export interface ReplaceCartDeliveryAddressRequest {
    addressId: string;
    baseSiteId: string;
    cartId: string;
    userId: string;
    sapCommerceCloudCustomerId?: string;
}

export interface UpdateBillingAddressRequest {
    baseSiteId: string;
    cartId: string;
    userId: string;
    address: Address;
    sapCommerceCloudCustomerId?: string;
}

/**
 * CartAddressesApi - interface
 * 
 * @export
 * @interface CartAddressesApiInterface
 */
export interface CartAddressesApiInterface {
    /**
     * 
     * @summary Creates a delivery address for the cart.
     * @param {string} baseSiteId Base site identifier.
     * @param {string} cartId Cart identifier: cart code for logged-in user, cart GUID for anonymous user, or \&#39;current\&#39; for the last modified cart.
     * @param {string} userId User identifier or one of the literals : \&#39;current\&#39; for currently authenticated user, \&#39;anonymous\&#39; for anonymous user.
     * @param {Address} address 
     * @param {string} [fields] Response configuration. This is the list of fields that should be returned in the response body. Examples: BASIC,DEFAULT,FULL
     * @param {string} [sapCommerceCloudCustomerId] Default B2B Unit of the B2B customer to be used during the request.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CartAddressesApiInterface
     */
    createCartDeliveryAddressRaw(requestParameters: CreateCartDeliveryAddressRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Address>>;

    /**
     * Creates a delivery address for the cart.
     */
    createCartDeliveryAddress(requestParameters: CreateCartDeliveryAddressRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Address>;

    /**
     * 
     * @summary Creates a payment address for the cart.
     * @param {string} baseSiteId Base site identifier.
     * @param {string} cartId Cart identifier: cart code for logged-in user, cart GUID for anonymous user, or \&#39;current\&#39; for the last modified cart.
     * @param {string} userId User identifier or one of the literals : \&#39;current\&#39; for currently authenticated user, \&#39;anonymous\&#39; for anonymous user.
     * @param {Address} address 
     * @param {string} [fields] Response configuration. This is the list of fields that should be returned in the response body. Examples: BASIC,DEFAULT,FULL
     * @param {string} [sapCommerceCloudCustomerId] Default B2B Unit of the B2B customer to be used during the request.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CartAddressesApiInterface
     */
    createCartPaymentAddressRaw(requestParameters: CreateCartPaymentAddressRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Address>>;

    /**
     * Creates a payment address for the cart.
     */
    createCartPaymentAddress(requestParameters: CreateCartPaymentAddressRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Address>;

    /**
     * Deletes the delivery address associated with a cart.
     * @summary Deletes the delivery address.
     * @param {string} baseSiteId Base site identifier.
     * @param {string} cartId Cart identifier: cart code for logged-in user, cart GUID for anonymous user, or \&#39;current\&#39; for the last modified cart.
     * @param {string} userId User identifier or one of the literals : \&#39;current\&#39; for currently authenticated user, \&#39;anonymous\&#39; for anonymous user.
     * @param {string} [sapCommerceCloudCustomerId] Default B2B Unit of the B2B customer to be used during the request.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CartAddressesApiInterface
     */
    removeCartDeliveryAddressRaw(requestParameters: RemoveCartDeliveryAddressRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Deletes the delivery address associated with a cart.
     * Deletes the delivery address.
     */
    removeCartDeliveryAddress(requestParameters: RemoveCartDeliveryAddressRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * 
     * @summary Removes the payment address from a cart.
     * @param {string} baseSiteId Base site identifier.
     * @param {string} cartId Cart identifier: cart code for logged-in user, cart GUID for anonymous user, or \&#39;current\&#39; for the last modified cart.
     * @param {string} id 
     * @param {string} userId User identifier or one of the literals : \&#39;current\&#39; for currently authenticated user, \&#39;anonymous\&#39; for anonymous user.
     * @param {boolean} [removeFromAddressBook] Should the address also be removed from the parent unit?
     * @param {string} [sapCommerceCloudCustomerId] Default B2B Unit of the B2B customer to be used during the request.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CartAddressesApiInterface
     */
    removePaymentAddressRaw(requestParameters: RemovePaymentAddressRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Removes the payment address from a cart.
     */
    removePaymentAddress(requestParameters: RemovePaymentAddressRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * The updated address country must be a valid delivery country for the current base store.
     * @summary Updates the delivery address for a cart.
     * @param {string} addressId Address identifier
     * @param {string} baseSiteId Base site identifier.
     * @param {string} cartId Cart identifier: cart code for logged-in user, cart GUID for anonymous user, or \&#39;current\&#39; for the last modified cart.
     * @param {string} userId User identifier or one of the literals : \&#39;current\&#39; for currently authenticated user, \&#39;anonymous\&#39; for anonymous user.
     * @param {string} [sapCommerceCloudCustomerId] Default B2B Unit of the B2B customer to be used during the request.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CartAddressesApiInterface
     */
    replaceCartDeliveryAddressRaw(requestParameters: ReplaceCartDeliveryAddressRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * The updated address country must be a valid delivery country for the current base store.
     * Updates the delivery address for a cart.
     */
    replaceCartDeliveryAddress(requestParameters: ReplaceCartDeliveryAddressRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * Creates or updates the billing address of the cart.
     * @summary Create or update the billing address of the cart.
     * @param {string} baseSiteId Base site identifier.
     * @param {string} cartId Cart identifier: cart code for logged-in user, cart GUID for anonymous user, or \&#39;current\&#39; for the last modified cart.
     * @param {string} userId User identifier or one of the literals : \&#39;current\&#39; for currently authenticated user, \&#39;anonymous\&#39; for anonymous user.
     * @param {Address} address 
     * @param {string} [sapCommerceCloudCustomerId] Default B2B Unit of the B2B customer to be used during the request.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CartAddressesApiInterface
     */
    updateBillingAddressRaw(requestParameters: UpdateBillingAddressRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Creates or updates the billing address of the cart.
     * Create or update the billing address of the cart.
     */
    updateBillingAddress(requestParameters: UpdateBillingAddressRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

}

/**
 * 
 */
export class CartAddressesApi extends runtime.BaseAPI implements CartAddressesApiInterface {

    /**
     * Creates a delivery address for the cart.
     */
    async createCartDeliveryAddressRaw(requestParameters: CreateCartDeliveryAddressRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Address>> {
        if (requestParameters.baseSiteId === null || requestParameters.baseSiteId === undefined) {
            throw new runtime.RequiredError('baseSiteId','Required parameter requestParameters.baseSiteId was null or undefined when calling createCartDeliveryAddress.');
        }

        if (requestParameters.cartId === null || requestParameters.cartId === undefined) {
            throw new runtime.RequiredError('cartId','Required parameter requestParameters.cartId was null or undefined when calling createCartDeliveryAddress.');
        }

        if (requestParameters.userId === null || requestParameters.userId === undefined) {
            throw new runtime.RequiredError('userId','Required parameter requestParameters.userId was null or undefined when calling createCartDeliveryAddress.');
        }

        if (requestParameters.address === null || requestParameters.address === undefined) {
            throw new runtime.RequiredError('address','Required parameter requestParameters.address was null or undefined when calling createCartDeliveryAddress.');
        }

        const queryParameters: any = {};

        if (requestParameters.fields !== undefined) {
            queryParameters['fields'] = requestParameters.fields;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/xml';

        if (requestParameters.sapCommerceCloudCustomerId !== undefined && requestParameters.sapCommerceCloudCustomerId !== null) {
            headerParameters['sap-commerce-cloud-customer-id'] = String(requestParameters.sapCommerceCloudCustomerId);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2_authorization_code", ["basic"]);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2_client_credentials", ["extended"]);
        }

        const response = await this.request({
            path: `/{baseSiteId}/users/{userId}/carts/{cartId}/addresses/delivery`.replace(`{${"baseSiteId"}}`, encodeURIComponent(String(requestParameters.baseSiteId))).replace(`{${"cartId"}}`, encodeURIComponent(String(requestParameters.cartId))).replace(`{${"userId"}}`, encodeURIComponent(String(requestParameters.userId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: AddressToJSON(requestParameters.address),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AddressFromJSON(jsonValue));
    }

    /**
     * Creates a delivery address for the cart.
     */
    async createCartDeliveryAddress(requestParameters: CreateCartDeliveryAddressRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Address> {
        const response = await this.createCartDeliveryAddressRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates a payment address for the cart.
     */
    async createCartPaymentAddressRaw(requestParameters: CreateCartPaymentAddressRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Address>> {
        if (requestParameters.baseSiteId === null || requestParameters.baseSiteId === undefined) {
            throw new runtime.RequiredError('baseSiteId','Required parameter requestParameters.baseSiteId was null or undefined when calling createCartPaymentAddress.');
        }

        if (requestParameters.cartId === null || requestParameters.cartId === undefined) {
            throw new runtime.RequiredError('cartId','Required parameter requestParameters.cartId was null or undefined when calling createCartPaymentAddress.');
        }

        if (requestParameters.userId === null || requestParameters.userId === undefined) {
            throw new runtime.RequiredError('userId','Required parameter requestParameters.userId was null or undefined when calling createCartPaymentAddress.');
        }

        if (requestParameters.address === null || requestParameters.address === undefined) {
            throw new runtime.RequiredError('address','Required parameter requestParameters.address was null or undefined when calling createCartPaymentAddress.');
        }

        const queryParameters: any = {};

        if (requestParameters.fields !== undefined) {
            queryParameters['fields'] = requestParameters.fields;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/xml';

        if (requestParameters.sapCommerceCloudCustomerId !== undefined && requestParameters.sapCommerceCloudCustomerId !== null) {
            headerParameters['sap-commerce-cloud-customer-id'] = String(requestParameters.sapCommerceCloudCustomerId);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2_authorization_code", ["basic"]);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2_client_credentials", ["extended"]);
        }

        const response = await this.request({
            path: `/{baseSiteId}/users/{userId}/carts/{cartId}/addresses/payment`.replace(`{${"baseSiteId"}}`, encodeURIComponent(String(requestParameters.baseSiteId))).replace(`{${"cartId"}}`, encodeURIComponent(String(requestParameters.cartId))).replace(`{${"userId"}}`, encodeURIComponent(String(requestParameters.userId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: AddressToJSON(requestParameters.address),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AddressFromJSON(jsonValue));
    }

    /**
     * Creates a payment address for the cart.
     */
    async createCartPaymentAddress(requestParameters: CreateCartPaymentAddressRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Address> {
        const response = await this.createCartPaymentAddressRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Deletes the delivery address associated with a cart.
     * Deletes the delivery address.
     */
    async removeCartDeliveryAddressRaw(requestParameters: RemoveCartDeliveryAddressRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.baseSiteId === null || requestParameters.baseSiteId === undefined) {
            throw new runtime.RequiredError('baseSiteId','Required parameter requestParameters.baseSiteId was null or undefined when calling removeCartDeliveryAddress.');
        }

        if (requestParameters.cartId === null || requestParameters.cartId === undefined) {
            throw new runtime.RequiredError('cartId','Required parameter requestParameters.cartId was null or undefined when calling removeCartDeliveryAddress.');
        }

        if (requestParameters.userId === null || requestParameters.userId === undefined) {
            throw new runtime.RequiredError('userId','Required parameter requestParameters.userId was null or undefined when calling removeCartDeliveryAddress.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters.sapCommerceCloudCustomerId !== undefined && requestParameters.sapCommerceCloudCustomerId !== null) {
            headerParameters['sap-commerce-cloud-customer-id'] = String(requestParameters.sapCommerceCloudCustomerId);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2_authorization_code", ["basic"]);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2_client_credentials", ["extended"]);
        }

        const response = await this.request({
            path: `/{baseSiteId}/users/{userId}/carts/{cartId}/addresses/delivery`.replace(`{${"baseSiteId"}}`, encodeURIComponent(String(requestParameters.baseSiteId))).replace(`{${"cartId"}}`, encodeURIComponent(String(requestParameters.cartId))).replace(`{${"userId"}}`, encodeURIComponent(String(requestParameters.userId))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Deletes the delivery address associated with a cart.
     * Deletes the delivery address.
     */
    async removeCartDeliveryAddress(requestParameters: RemoveCartDeliveryAddressRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.removeCartDeliveryAddressRaw(requestParameters, initOverrides);
    }

    /**
     * Removes the payment address from a cart.
     */
    async removePaymentAddressRaw(requestParameters: RemovePaymentAddressRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.baseSiteId === null || requestParameters.baseSiteId === undefined) {
            throw new runtime.RequiredError('baseSiteId','Required parameter requestParameters.baseSiteId was null or undefined when calling removePaymentAddress.');
        }

        if (requestParameters.cartId === null || requestParameters.cartId === undefined) {
            throw new runtime.RequiredError('cartId','Required parameter requestParameters.cartId was null or undefined when calling removePaymentAddress.');
        }

        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling removePaymentAddress.');
        }

        if (requestParameters.userId === null || requestParameters.userId === undefined) {
            throw new runtime.RequiredError('userId','Required parameter requestParameters.userId was null or undefined when calling removePaymentAddress.');
        }

        const queryParameters: any = {};

        if (requestParameters.removeFromAddressBook !== undefined) {
            queryParameters['removeFromAddressBook'] = requestParameters.removeFromAddressBook;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters.sapCommerceCloudCustomerId !== undefined && requestParameters.sapCommerceCloudCustomerId !== null) {
            headerParameters['sap-commerce-cloud-customer-id'] = String(requestParameters.sapCommerceCloudCustomerId);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2_authorization_code", ["basic"]);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2_client_credentials", ["extended"]);
        }

        const response = await this.request({
            path: `/{baseSiteId}/users/{userId}/carts/{cartId}/addresses/payment/{id}`.replace(`{${"baseSiteId"}}`, encodeURIComponent(String(requestParameters.baseSiteId))).replace(`{${"cartId"}}`, encodeURIComponent(String(requestParameters.cartId))).replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))).replace(`{${"userId"}}`, encodeURIComponent(String(requestParameters.userId))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Removes the payment address from a cart.
     */
    async removePaymentAddress(requestParameters: RemovePaymentAddressRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.removePaymentAddressRaw(requestParameters, initOverrides);
    }

    /**
     * The updated address country must be a valid delivery country for the current base store.
     * Updates the delivery address for a cart.
     */
    async replaceCartDeliveryAddressRaw(requestParameters: ReplaceCartDeliveryAddressRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.addressId === null || requestParameters.addressId === undefined) {
            throw new runtime.RequiredError('addressId','Required parameter requestParameters.addressId was null or undefined when calling replaceCartDeliveryAddress.');
        }

        if (requestParameters.baseSiteId === null || requestParameters.baseSiteId === undefined) {
            throw new runtime.RequiredError('baseSiteId','Required parameter requestParameters.baseSiteId was null or undefined when calling replaceCartDeliveryAddress.');
        }

        if (requestParameters.cartId === null || requestParameters.cartId === undefined) {
            throw new runtime.RequiredError('cartId','Required parameter requestParameters.cartId was null or undefined when calling replaceCartDeliveryAddress.');
        }

        if (requestParameters.userId === null || requestParameters.userId === undefined) {
            throw new runtime.RequiredError('userId','Required parameter requestParameters.userId was null or undefined when calling replaceCartDeliveryAddress.');
        }

        const queryParameters: any = {};

        if (requestParameters.addressId !== undefined) {
            queryParameters['addressId'] = requestParameters.addressId;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters.sapCommerceCloudCustomerId !== undefined && requestParameters.sapCommerceCloudCustomerId !== null) {
            headerParameters['sap-commerce-cloud-customer-id'] = String(requestParameters.sapCommerceCloudCustomerId);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2_authorization_code", ["basic"]);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2_client_credentials", ["extended"]);
        }

        const response = await this.request({
            path: `/{baseSiteId}/users/{userId}/carts/{cartId}/addresses/delivery`.replace(`{${"baseSiteId"}}`, encodeURIComponent(String(requestParameters.baseSiteId))).replace(`{${"cartId"}}`, encodeURIComponent(String(requestParameters.cartId))).replace(`{${"userId"}}`, encodeURIComponent(String(requestParameters.userId))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * The updated address country must be a valid delivery country for the current base store.
     * Updates the delivery address for a cart.
     */
    async replaceCartDeliveryAddress(requestParameters: ReplaceCartDeliveryAddressRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.replaceCartDeliveryAddressRaw(requestParameters, initOverrides);
    }

    /**
     * Creates or updates the billing address of the cart.
     * Create or update the billing address of the cart.
     */
    async updateBillingAddressRaw(requestParameters: UpdateBillingAddressRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.baseSiteId === null || requestParameters.baseSiteId === undefined) {
            throw new runtime.RequiredError('baseSiteId','Required parameter requestParameters.baseSiteId was null or undefined when calling updateBillingAddress.');
        }

        if (requestParameters.cartId === null || requestParameters.cartId === undefined) {
            throw new runtime.RequiredError('cartId','Required parameter requestParameters.cartId was null or undefined when calling updateBillingAddress.');
        }

        if (requestParameters.userId === null || requestParameters.userId === undefined) {
            throw new runtime.RequiredError('userId','Required parameter requestParameters.userId was null or undefined when calling updateBillingAddress.');
        }

        if (requestParameters.address === null || requestParameters.address === undefined) {
            throw new runtime.RequiredError('address','Required parameter requestParameters.address was null or undefined when calling updateBillingAddress.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters.sapCommerceCloudCustomerId !== undefined && requestParameters.sapCommerceCloudCustomerId !== null) {
            headerParameters['sap-commerce-cloud-customer-id'] = String(requestParameters.sapCommerceCloudCustomerId);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2_authorization_code", ["basic"]);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2_client_credentials", ["extended"]);
        }

        const response = await this.request({
            path: `/{baseSiteId}/users/{userId}/carts/{cartId}/addresses/billing`.replace(`{${"baseSiteId"}}`, encodeURIComponent(String(requestParameters.baseSiteId))).replace(`{${"cartId"}}`, encodeURIComponent(String(requestParameters.cartId))).replace(`{${"userId"}}`, encodeURIComponent(String(requestParameters.userId))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: AddressToJSON(requestParameters.address),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Creates or updates the billing address of the cart.
     * Create or update the billing address of the cart.
     */
    async updateBillingAddress(requestParameters: UpdateBillingAddressRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.updateBillingAddressRaw(requestParameters, initOverrides);
    }

}
